// extracted by mini-css-extract-plugin
export default {"wrapper":"Pagination_wrapper__CdeaB","icon":"Pagination_icon__RzxOJ","active":"Pagination_active__DDld0","text":"Pagination_text__xb4KQ"};